export class PaymentValidationSet {
    customOrDefault: string;
    paymentValidationSetOptions: PaymentValidationSetOption[];

    constructor(props?: { [key in keyof PaymentValidationSet]?: PaymentValidationSet[key] }) {
        Object.assign(this, props);
    }
}

export class PaymentValidationSetOption {
    paymentType: string;
    paymentTypeValues: string;

    constructor(props?: { [key in keyof PaymentValidationSetOption]?: PaymentValidationSetOption[key] }) {
        Object.assign(this, props);
    }
}
